import * as React from 'react';
import {
    TextField,
    useTranslate,
    useRecordContext,
    BooleanField,
} from 'react-admin';
import { Typography, Card, CardContent, Box, Grid } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { Page } from '../../types';

const Aside = () => {
    const record = useRecordContext<Page>();
    return (
        <Box width={400} display={{ xs: 'none', lg: 'block' }}>
            {record && <EventList />}
        </Box>
    );
};

const EventList = () => {
    const record = useRecordContext<Page>();
    const translate = useTranslate();
    // const [locale] = useLocaleState();

    return (
        <Box ml={2}>
            <Card>
                <CardContent>
                    <Grid container rowSpacing={1} columnSpacing={1}>
                        <Grid item xs={12} display="flex" gap={1}>
                            <AccessTimeIcon fontSize="small" color="disabled" />
                            <Box flexGrow={1}>
                                <Typography variant="body2">
                                    {translate(
                                        'resources.city_items_pages.fields.slug'
                                    )}
                                </Typography>
                                <TextField record={record} source="slug" />
                            </Box>
                        </Grid>
                        <Grid item xs={6} display="flex" gap={1}>
                            <AccessTimeIcon fontSize="small" color="disabled" />
                            <Box flexGrow={1}>
                                <Typography variant="body2">
                                    {translate(
                                        'resources.city_items_pages.fields.template_from'
                                    )}
                                </Typography>
                                <BooleanField
                                    record={record}
                                    source="template_from"
                                />
                                <TextField record={record} source="slug" />
                                <Typography variant="body2">
                                    {translate(
                                        'resources.city_items_pages.fields.city_from'
                                    )}
                                </Typography>
                                <TextField
                                    record={record}
                                    source="city_item_from.title"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={6} display="flex" gap={1}>
                            <AccessTimeIcon fontSize="small" color="disabled" />
                            <Box flexGrow={1}>
                                <Typography variant="body2">
                                    {translate(
                                        'resources.city_items_pages.fields.template_to'
                                    )}
                                </Typography>
                                <BooleanField
                                    record={record}
                                    source="template_to"
                                />
                                <Typography variant="body2">
                                    {translate(
                                        'resources.city_items_pages.fields.city_to'
                                    )}
                                </Typography>
                                <TextField
                                    record={record}
                                    source="city_item_to.title"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Aside;
